// Canonical sale/discount form shape: option lists, the form value type, and
// the empty template. Moved here from
// client/src/pages/sales-discount-form.tsx (which re-exports everything) so
// the server-side Build-with-AI persist path can normalize builder output
// with the exact same source of truth the form uses. Pure data — no React,
// no UI imports.

export const SALE_TYPES: { value: string; label: string }[] = [
  { value: "percentage_off", label: "Percentage Off" },
  { value: "dollar_off", label: "Dollar Off" },
  { value: "free_shipping", label: "Free Shipping" },
  { value: "bogo", label: "Buy One Get One" },
  { value: "bundle", label: "Bundle Deal" },
  { value: "first_order", label: "First Order Discount" },
  { value: "subscription", label: "Subscription Discount" },
  { value: "limited_time", label: "Limited-Time Promo" },
  { value: "gwp", label: "Gift With Purchase" },
  { value: "custom", label: "Custom" },
];

export const URGENCY_MECHANISMS: { value: string; label: string }[] = [
  { value: "ends_soon", label: "Ends Soon" },
  { value: "limited_quantity", label: "Limited Quantity" },
  { value: "seasonal_event", label: "Seasonal Event" },
  { value: "first_time_only", label: "First-Time Customer Only" },
  { value: "subscriber_exclusive", label: "Subscriber Exclusive" },
  { value: "launch_promo", label: "Launch Promo" },
  { value: "holiday_promo", label: "Holiday Promo" },
  { value: "no_urgency", label: "No Urgency" },
  { value: "custom", label: "Custom" },
];

export const APPLIES_TO_SCOPES: { value: string; label: string }[] = [
  { value: "products", label: "Specific products" },
  { value: "offers", label: "Specific offers" },
  { value: "brand", label: "Entire brand / store" },
];

export const SALE_STATUSES: { value: string; label: string }[] = [
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "paused", label: "Paused" },
  { value: "expired", label: "Expired" },
];

export interface SalesDiscountFormValue {
  name: string;
  saleType: string;
  discountValue?: string | null;
  appliesTo?: { scope: string; productIds: string[]; offerIds: string[] } | null;
  primaryProductId?: string | null;
  primaryOfferId?: string | null;
  promotionSummary?: string | null;
  customerFacingCopy?: string | null;
  whyThisSaleExists?: string | null;
  urgencyMechanism?: string | null;
  expirationDate?: string | null;
  promoCode?: string | null;
  termsConditions?: string | null;
  ctaLanguage?: string | null;
  creativeNotes?: string | null;
  status: string;
}

export const emptySalesDiscount = (): SalesDiscountFormValue => ({
  name: "",
  saleType: "percentage_off",
  discountValue: "",
  appliesTo: { scope: "brand", productIds: [], offerIds: [] },
  primaryProductId: null,
  primaryOfferId: null,
  promotionSummary: "",
  customerFacingCopy: "",
  whyThisSaleExists: "",
  urgencyMechanism: "no_urgency",
  expirationDate: null,
  promoCode: "",
  termsConditions: "",
  ctaLanguage: "",
  creativeNotes: "",
  status: "draft",
});
